import { Link } from 'react-scroll';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

// WHY: Type-safe size variants using mapped type
// Each size defines a height for the logo image
type LogoSize = 'small' | 'regular' | 'large' | 'superLarge';

const sizes: Record<LogoSize, FlattenSimpleInterpolation> = {
  small: css`
    height: 64px;
  `,
  regular: css`
    height: 10rem;
  `,
  large: css`
    height: 96px;
  `,
  superLarge: css`
    height: 128px;
    @media screen and (max-width: 821px) {
    }
  `,
};

const StyledLogo = styled.div`
  text-align: center;
`;

const Img = styled.img<{ size: LogoSize }>`
  width: auto;

  ${(props) => sizes[props.size]}
`;

// WHY: Define interface for Logo props
// Flexible logo component with responsive sizing and optional smooth scroll link
// Used for channel logos throughout the platform
export interface LogoProps {
  src: string; // Logo image URL
  alt?: string; // Alt text for accessibility
  size?: LogoSize; // Size variant
  linkUrl?: boolean; // Whether to wrap in react-scroll Link
  style?: React.CSSProperties; // Additional styling
}

function Logo({
  src,
  alt = 'Logo',
  size = 'regular',
  linkUrl,
  style,
}: LogoProps) {
  return (
    <StyledLogo style={style}>
      {/* WHY: Conditional react-scroll Link wrapper */}
      {/* When linkUrl is true, clicking logo scrolls to #home section */}
      {linkUrl && (
        <Link href="#home" to="home" spy={true} smooth={'true'} duration={500}>
          <Img src={src} alt={alt} size={size} />
        </Link>
      )}
      {/* WHY: Static image when no link needed */}
      {!linkUrl && <Img src={src} alt={alt} size={size} />}
    </StyledLogo>
  );
}

export default Logo;
